(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../constants", "../hooks/useActive"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../constants"), require("../hooks/useActive"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.constants, global.useActive);
    global.useTransitionHandlers = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _constants, _useActive) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useTransitionHandlers = useTransitionHandlers;

  function isScrollable(element) {
    // Compare the height to see if the element has scrollable content
    var hasScrollableContent = element.scrollHeight > element.clientHeight; // It's not enough because the element's `overflow-y` style can be set as
    // * `hidden`
    // * `hidden !important`
    // In those cases, the scrollbar isn't shown

    var overflowYStyle = window.getComputedStyle(element).overflowY;
    var isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;
    return hasScrollableContent && !isOverflowHidden;
  }

  function useTransitionHandlers() {
    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        locationHistory = _useContext.locationHistory;

    var routeMatch = (0, _reactRouter.useRouteMatch)();
    var active = (0, _useActive.useActive)();
    var history = (0, _reactRouter.useHistory)();
    var onEnter = (0, _react.useCallback)(function (node) {
      if (active) node.removeAttribute('hidden');

      if (history.action === _constants.POP) {
        var state = locationHistory.get(routeMatch.key);
        if (state !== null && state !== void 0 && state.scrollTop) node.scrollTop = state.scrollTop;
      }
    }, [active, history, routeMatch.key, locationHistory]);
    var onEntering = (0, _react.useCallback)(function (node) {}, []);
    var onEntered = (0, _react.useCallback)(function (node) {
      if (active) node.removeAttribute('hidden');
    }, [active]);
    var onExit = (0, _react.useCallback)(function (node) {
      if (isScrollable(node)) {
        locationHistory.set(routeMatch.key, {
          scrollTop: node.scrollTop,
          scrollHeight: node.scrollHeight
        });
      }
    }, [routeMatch.key, locationHistory]);
    var onExiting = (0, _react.useCallback)(function (node) {}, []);
    var onExited = (0, _react.useCallback)(function (node) {
      if (!active) node.setAttribute('hidden', 'hidden');
    }, [active]);
    return {
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited
    };
  }
});